
import dayjs from 'dayjs';
import 'dayjs/locale/es';


export const obtenerNumCuotasPagas = ({totalAhorro, cuotaNormal}) =>{


    let cuotasPagas = ~~(totalAhorro / cuotaNormal)

    return cuotasPagas


}